<template>
  <p class="tooltip">
    {{ displayName }}
    <span class="tooltiptext">{{ displayName }}</span>
  </p>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { useProductsContext } from "../../useProductsContext";
import type { IProductTableData } from "@/types/db/product-category";

type Props = {
  row: IProductTableData;
};

const props = defineProps<Props>();
const ctx = useProductsContext();

/**
 * Localized name with fallback to raw `name` when the locale entry is empty.
 * Mirrors the legacy template's two-branch v-if/v-else structure.
 *
 * @returns {string}
 */
const displayName = computed((): string => {
  const translated = ctx.getTranslationForProducts(props.row.nameLocale);

  return translated === "" ? props.row.name : translated;
});
</script>
